import { useRef, useState } from 'react';

/**
 * Filtros de relatório em drawer: `draft` é editado no drawer e só vira `applied` em apply().
 * `count` = filtros aplicados que diferem do valor padrão.
 */
export default function useReportFilters(getDefaults) {
    const defaults = useRef(null);
    if (defaults.current === null) {
        defaults.current = typeof getDefaults === 'function' ? getDefaults() : getDefaults;
    }

    const [applied, setApplied] = useState(defaults.current);
    const [draft, setDraft] = useState(defaults.current);
    const [open, setOpen] = useState(false);

    const count = Object.keys(defaults.current).filter(
        (key) => JSON.stringify(applied[key]) !== JSON.stringify(defaults.current[key])
    ).length;

    return {
        applied,
        draft,
        open,
        count,
        set: (key, value) => setDraft((prev) => ({ ...prev, [key]: value })),
        openDrawer: () => {
            setDraft(applied);
            setOpen(true);
        },
        close: () => setOpen(false),
        apply: () => {
            setApplied(draft);
            setOpen(false);
        },
        clear: () => {
            setApplied(defaults.current);
            setDraft(defaults.current);
            setOpen(false);
        },
    };
}
